import RangePicker from './components/RangePicker';
import { PbRenderElementPlugin } from '@whalecloud/page-builder-core/utils/types';

export default (): PbRenderElementPlugin => ({
  name: 'rangePicker',
  pluginComponent: RangePicker,
});
